const binding = { modules: {}, dataActions: {} };

    (binding.modules['cookie-compliance'] = {
        c: () => require('@msdyn365-commerce-modules/cookie-compliance/dist/lib/modules/cookie-compliance/cookie-compliance'),
        $type: 'contentModule',
        da: [],
        
        iNM: true,
        ns: '@msdyn365-commerce-modules',
        n: 'cookie-compliance',
        p: 'cookie-compliance',
        
        pdp: '',
        
        
        md: 'node_modules/@msdyn365-commerce-modules/cookie-compliance/dist/lib/modules/cookie-compliance'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|themes|moekwrsitetheme|views|cookie-compliance'] = {
                c: () => require('partner/themes/moekwrsitetheme/views/cookie-compliance.view.tsx'),
                cn: '__local__-__local__-cookie-compliance'
            };
viewDictionary['__local__|__local__|themes|moenzcsitetheme|views|cookie-compliance'] = {
                c: () => require('partner/themes/moenzcsitetheme/views/cookie-compliance.view.tsx'),
                cn: '__local__-__local__-cookie-compliance'
            };
viewDictionary['__local__|__local__|themes|moeochsitetheme|views|cookie-compliance'] = {
                c: () => require('partner/themes/moeochsitetheme/views/cookie-compliance.view.tsx'),
                cn: '__local__-__local__-cookie-compliance'
            };
viewDictionary['__local__|__local__|themes|moetwksitetheme|views|cookie-compliance'] = {
                c: () => require('partner/themes/moetwksitetheme/views/cookie-compliance.view.tsx'),
                cn: '__local__-__local__-cookie-compliance'
            };
viewDictionary['@msdyn365-commerce-modules|cookie-compliance|modules|cookie-compliance|cookie-compliance'] = {
                c: () => require('@msdyn365-commerce-modules/cookie-compliance/dist/lib/modules/cookie-compliance/cookie-compliance.view.js'),
                cn: '@msdyn365-commerce-modules-cookie-compliance-cookie-compliance'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };